import {Pipe, PipeTransform} from '@angular/core';
import {UserSessionDto} from '../../Models/User/user-session.interface';
import {CommunicationDto} from '../../Models/Communication/communication.interface';
import {CommunicationTypesEnum} from '../../Shared/Enum/communication-types.enum';

@Pipe({
  name: 'communicationPermission',
  standalone: false,
})
export class CommunicationPermissionPipe implements PipeTransform {

  transform(items: CommunicationDto[], user: UserSessionDto | null): CommunicationDto[] {

    if (!items?.length || !user) {
      return [];
    }

    const communicationPermission = {
      [CommunicationTypesEnum.chats]: user.permisos.application.chats.ver,
      [CommunicationTypesEnum.events]: user.permisos.application.eventos.ver,
      [CommunicationTypesEnum.lists]: user.permisos.application.listas.ver,
      [CommunicationTypesEnum.meetings]: user.permisos.application.reuniones.ver,
      [CommunicationTypesEnum.warnings]: user.permisos.application.avisos.ver,
      [CommunicationTypesEnum.breakdowns]: user.permisos.application.averias.ver,
    } as Record<number, boolean>;

    return items.filter((item) => communicationPermission[item.id_subtipo] ?? true);

  }

}
